/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const collectionRefSchema = z.object({
  id: z.number(),
  title: z.string(),
  parent: z
    .object({
      id: z.number(),
      title: z.string(),
    })
    .nullable(),
});

export const reviewerRecentChallengeRowSchema = z.object({
  challenge: z.object({ id: z.number(), title: z.string() }),
  collection: collectionRefSchema.nullable(),
  approved: z.number(),
  rejected: z.number(),
  totalDecisionMs: z.number().nullable(),
  lastActedAt: z.number(),
});

export const listReviewerPerformanceRecentChallengesV1DataSchema = z.object({
  userId: z.string(),
  rows: z.array(reviewerRecentChallengeRowSchema),
});

export type IReviewerRecentChallengeRow = z.infer<typeof reviewerRecentChallengeRowSchema>;
export type IListReviewerPerformanceRecentChallengesV1Data = z.infer<
  typeof listReviewerPerformanceRecentChallengesV1DataSchema
>;

export const listReviewerPerformanceRecentChallengesV1ResponseSchema = createApiResponseSchema(
  listReviewerPerformanceRecentChallengesV1DataSchema,
) as z.ZodSchema<IAPI<IListReviewerPerformanceRecentChallengesV1Data>>;

export type IListReviewerPerformanceRecentChallengesV1Response =
  IAPI<IListReviewerPerformanceRecentChallengesV1Data>;
